import type { FC, PropsWithChildren } from 'react';
import { Flex, Typography } from '@ui';
import clsx from 'clsx';
import styles from './GenericPageSectionWrapper.module.css';

type Props = {
    title?: string;
    size?: 'm' | 'l' | 'xl';
    relative?: boolean;
} & PropsWithChildren;

export const GenericPageSectionWrapper: FC<Props> = ({ title, size = 'm', relative, children }) => (
    <Flex vertical gap={80} className={clsx(styles[`container-${size}`], relative && styles.relative)}>
        {title && <Typography.Heading level={1} color="textSecondary">{title}</Typography.Heading>}
        {children}
    </Flex>
);
